import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';

import "react-toastify/dist/ReactToastify.css";

import Login from '../views/Login';
import { UserContext } from './Context/userContext';
import { useProgressBar } from '../views/ProgressBar';
import { startSignalRConnection, getSignalRConnection } from "../services/signalRService";


const LoginComponent = () => {
    const { login } = useContext(UserContext);
    const { showProgress } = useProgressBar();
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
   
    const parentMethod = async (username, password) => {
       
        try {
            debugger;
            const response = await login(username, password);
            showProgress(false);
            if (response.status === 200) {
              
                // Start SignalR connection on component mount
            
                 startSignalRConnection();
               

          
                const trimmedUserType = response.data.userType.trim().toUpperCase();

                if (trimmedUserType === 'ADMIN') {
                    navigate('/dashboard');
                } else if (trimmedUserType === 'PARTNER') {
                    navigate('/dashboard');
                } else if (trimmedUserType === 'EMPLOYEE') {
                    navigate('/dashboard');
                }
            } else {
                alert('Login failed! Incorrect username or password.');
            }

        } catch (error) {
            showProgress(false);
            if (error.status == 401) {
               
                setErrorMessage("Login failed! Incorrect username or password.");
                alert("Login failed! Incorrect username or password.");
            }
            else {
                setErrorMessage(error.message);
                alert(error.message);
            }
            
        }
    };

    return (
        
           
        <Login callParentMethod={parentMethod} errorMessage={errorMessage} />
    );
};

export default LoginComponent;
